import React, { forwardRef } from 'react';

import { Box, Radio, RadioGroup, Stack, styled } from '@mui/material';

import Check from 'images/components/check.svg';
import CircleCheck from 'images/components/circle-check.svg';

const StyledRadio = styled(Radio)(({ theme, checked }) => ({
  padding          : '0 0 0 0',
  '& .StyledLabel' : {
    padding   : '15px 15px 15px 50px',
    minHeight : '50px',
    width     : '100%',

    background         : theme.palette.primary.white,
    backgroundImage    : `url(${CircleCheck})`,
    backgroundRepeat   : 'no-repeat',
    backgroundPosition : '18px 50%',

    color         : theme.palette.primary.gray100,
    fontFamily    : 'Montserrat',
    fontWeight    : 400,
    fontSize      : '14px',
    fontStyle     : 'normal',
    lineHeight    : '17px',
    textTransform : 'none',
    textAlign     : 'left',
    wordWrap      : 'normal',
    opacity       : 0.8,

    borderWidth  : '1px',
    borderStyle  : 'solid',
    borderColor  : theme.palette.primary.gray15,
    borderRadius : '6px',
    position     : 'relative',

    boxSizing : 'border-box',
    resize    : 'none',
  },
  '&:hover' : {
    '& .StyledLabel:not(.StyledLabel-checked)' : {
      borderColor : theme.palette.primary.blue1,
      borderWidth : '2px',
      color       : theme.palette.primary.blue1,
      fontWeight  : 700,
    },
  },
  '& .StyledLabel-checked' : {
    backgroundImage : `url(${Check})`,
    fontWeight      : 600,
    color           : theme.palette.primary.blue1,
    boxShadow       : `0 0 0 2px ${theme.palette.primary.blue1}`,
    borderColor     : 'rgba(0, 0, 0, 0)',
  },
}));

export const RadioInput = (props) => {
  const { label, ...rest } = props;
  return (
    <StyledRadio
      disableRipple
      color='default'
      checkedIcon={
        <Box
          className='StyledLabel StyledLabel-checked' data-testid='checked-label'>{label}</Box>
      }
      icon={<Box
        className='StyledLabel' data-testid='unchecked-label'>{label}</Box>}
      data-testid='radio-input'
      {...rest}
    />
  );
};

export const RadioGroupInput = forwardRef(
  ({ children, direction = 'column', optionsStyles, ...rest }, ref) => (
    <RadioGroup
      ref={ref} {...rest}>
      <Stack
        spacing='15px' direction={direction} sx={optionsStyles}>
        {children}
      </Stack>
    </RadioGroup>
  )
);
